export default "__VITE_PUBLIC_ASSET__44a14c69__"